/**
 * @generated SignedSource<<0ba4ef43fd5833c2cb7588ea2338456a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type STAGE = "DEV" | "PUBLISH" | "QC" | "%future added value";
export type SourceInput = {
  displayName?: string | null;
  envs?: ReadonlyArray<VariableInput | null> | null;
  preconfiguredSourceName: string;
  schedule: string;
  version?: string | null;
};
export type VariableInput = {
  name: string;
  value: string;
};
export type ModelInput = {
  displayName?: string | null;
  egressedTables?: ReadonlyArray<string | null> | null;
  envs?: ReadonlyArray<VariableInput | null> | null;
  preconfiguredModelName: string;
  prefix?: string | null;
  schedule: string;
  suffix?: string | null;
  version?: number | null;
};
export type createConnectorMutation$variables = {
  displayName: string;
  modelNames?: ReadonlyArray<string> | null;
  models?: ReadonlyArray<ModelInput | null> | null;
  sourceNames?: ReadonlyArray<string> | null;
  sources?: ReadonlyArray<SourceInput | null> | null;
  stage?: STAGE | null;
};
export type createConnectorMutation$data = {
  readonly createConnector: {
    readonly displayName: string | null;
    readonly models: ReadonlyArray<{
      readonly name: string;
    }>;
    readonly name: string;
  };
};
export type createConnectorMutation = {
  response: createConnectorMutation$data;
  variables: createConnectorMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "displayName"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "modelNames"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "models"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceNames"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sources"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stage"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "displayName",
        "variableName": "displayName"
      },
      {
        "kind": "Variable",
        "name": "modelNames",
        "variableName": "modelNames"
      },
      {
        "kind": "Variable",
        "name": "models",
        "variableName": "models"
      },
      {
        "kind": "Variable",
        "name": "sourceNames",
        "variableName": "sourceNames"
      },
      {
        "kind": "Variable",
        "name": "sources",
        "variableName": "sources"
      },
      {
        "kind": "Variable",
        "name": "stage",
        "variableName": "stage"
      }
    ],
    "concreteType": "Connector",
    "kind": "LinkedField",
    "name": "createConnector",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      },
      (v6/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "models",
        "plural": true,
        "selections": [
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "createConnectorMutation",
    "selections": (v7/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "createConnectorMutation",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "e3ab552d155d82265d0eb088d131cfa3",
    "id": null,
    "metadata": {},
    "name": "createConnectorMutation",
    "operationKind": "mutation",
    "text": "mutation createConnectorMutation(\n  $displayName: String!\n  $sourceNames: [String!]\n  $modelNames: [String!]\n  $sources: [SourceInput]\n  $models: [ModelInput]\n  $stage: STAGE\n) {\n  createConnector(displayName: $displayName, sourceNames: $sourceNames, modelNames: $modelNames, sources: $sources, models: $models, stage: $stage) {\n    displayName\n    name\n    models {\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bcf9abfed3f72be34de440c5a35ca67b";

export default node;
